export var Screen;
(function (Screen) {
    Screen["ACCOUNT_PAGE_INIT_ACCOUNT"] = "ACCOUNT_PAGE_INIT_ACCOUNT";
    Screen["ACCOUNT_PAGE_ADD_BY_KEYS"] = "ACCOUNT_PAGE_ADD_BY_KEYS";
    Screen["ACCOUNT_PAGE_ADD_BY_AUTH"] = "ACCOUNT_PAGE_ADD_BY_AUTH";
    Screen["ACCOUNT_PAGE_IMPORT_KEYS"] = "ACCOUNT_PAGE_IMPORT_KEYS";
    Screen["ACCOUNT_PAGE_SELECT_KEYS"] = "ACCOUNT_PAGE_SELECT_KEYS";
    Screen["CREATE_ACCOUNT_PAGE_STEP_ONE"] = "CREATE_ACCOUNT_PAGE_STEP_ONE";
    Screen["CREATE_ACCOUNT_PAGE_STEP_TWO"] = "CREATE_ACCOUNT_PAGE_STEP_TWO";
    Screen["SIGN_IN_ROUTER"] = "SIGN_IN_ROUTER";
    Screen["SIGN_IN_PAGE"] = "SIGN_IN_PAGE";
    Screen["SIGN_UP_PAGE"] = "SIGN_UP_PAGE";
    Screen["RESET_PASSWORD_PAGE"] = "RESET_PASSWORD_PAGE";
    Screen["HOME_PAGE"] = "HOME_PAGE";
    Screen["TRANSFER_FUND_PAGE"] = "TRANSFER_FUND_PAGE";
    Screen["POWER_UP_PAGE"] = "POWER_UP_PAGE";
    Screen["POWER_DOWN_PAGE"] = "POWER_DOWN_PAGE";
    Screen["GOVERNANCE_PAGE"] = "GOVERNANCE_PAGE";
    Screen["TOKENS_PAGE"] = "TOKENS_PAGE";
    Screen["TOKENS_HISTORY"] = "TOKENS_HISTORY";
    Screen["TOKENS_FILTER"] = "TOKENS_FILTER";
    Screen["TOKENS_SETTINGS"] = "TOKENS_SETTINGS";
    Screen["TOKENS_TRANSFER"] = "TOKENS_TRANSFER";
    Screen["TOKENS_OPERATION"] = "TOKENS_OPERATION";
    Screen["TOKENS_DELEGATIONS"] = "TOKENS_DELEGATIONS";
    Screen["TOKENS_PENDING_UNSTAKE"] = "TOKENS_PENDING_UNSTAKE";
    Screen["TOKEN_SWAP_PAGE"] = "TOKEN_SWAP_PAGE";
    Screen["TOKENS_SWAP_HISTORY"] = "TOKENS_SWAP_HISTORY";
    Screen["WALLET_HISTORY_PAGE"] = "WALLET_HISTORY_PAGE";
    Screen["ACCOUNT_VALUE_EXPLANATION"] = "ACCOUNT_VALUE_EXPLANATION";
    Screen["BUY_COINS_PAGE"] = "BUY_COINS_PAGE";
    Screen["CONFIRMATION_PAGE"] = "CONFIRMATION_PAGE";
    Screen["CONFIRMATION_TRANSFER_PAGE"] = "CONFIRMATION_TRANSFER_PAGE";
    Screen["CONVERSION_PAGE"] = "CONVERSION_PAGE";
    Screen["PENDING_CONVERSION_PAGE"] = "PENDING_CONVERSION_PAGE";
    Screen["SAVINGS_PAGE"] = "SAVINGS_PAGE";
    Screen["PENDING_SAVINGS_WITHDRAWAL_PAGE"] = "PENDING_SAVINGS_WITHDRAWAL_PAGE";
    Screen["DELEGATION_PAGE"] = "DELEGATION_PAGE";
    Screen["INCOMING_OUTGOING_PAGE"] = "INCOMING_OUTGOING_PAGE";
    Screen["RC_DELEGATIONS_PAGE"] = "RC_DELEGATIONS_PAGE";
    Screen["RC_DELEGATIONS_INCOMING_OUTGOING_PAGE"] = "RC_DELEGATIONS_INCOMING_OUTGOING_PAGE";
    Screen["SETTINGS_MAIN_PAGE"] = "SETTINGS_MAIN_PAGE";
    Screen["HISTORY_PAGE"] = "history_page";
    Screen["SETTINGS_ACCOUNTS"] = "SETTINGS_ACCOUNTS";
    Screen["SETTINGS_ADD_ACCOUNT"] = "ACCOUNT_PAGE_INIT_ACCOUNT";
    Screen["SETTINGS_MANAGE_ACCOUNTS"] = "SETTINGS_MANAGE_ACCOUNTS";
    Screen["SETTINGS_MANAGE_ACCOUNTS_AUTHORITIES"] = "SETTINGS_MANAGE_ACCOUNTS_AUTHORITIES";
    Screen["SETTINGS_ADD_KEY"] = "SETTINGS_ADD_KEY";
    Screen["SETTINGS_ACCOUNT_IMPORT_EXPORT"] = "SETTINGS_ACCOUNT_IMPORT_EXPORT";
    Screen["SETTINGS_ADVANCED"] = "SETTINGS_ADVANCED";
    Screen["SETTINGS_CHANGE_PASSWORD"] = "SETTINGS_CHANGE_PASSWORD";
    Screen["SETTINGS_RPC_NODES"] = "SETTINGS_RPC_NODES";
    Screen["SETTINGS_AUTO_LOCK"] = "SETTINGS_AUTO_LOCK";
    Screen["SETTINGS_KEYCHAINIFY"] = "SETTINGS_KEYCHAINIFY";
    Screen["SETTINGS_CLEAR_ALL_DATA"] = "SETTINGS_CLEAR_ALL_DATA";
    Screen["SETTINGS_IMPORT_EXPORT"] = "SETTINGS_IMPORT_EXPORT";
    Screen["SETTINGS_USER_PREFERENCES"] = "SETTINGS_USER_PREFERENCES";
    Screen["SETTINGS_AUTOMATED_TASKS"] = "SETTINGS_AUTOMATED_TASKS";
    Screen["SETTINGS_AUTHORIZED_OPERATIONS"] = "SETTINGS_AUTHORIZED_OPERATIONS";
    Screen["SETTINGS_EXPORT_TRANSACTIONS"] = "SETTINGS_EXPORT_TRANSACTIONS";
    Screen["SETTINGS_FAVORITE_ACCOUNTS"] = "SETTINGS_FAVORITE_ACCOUNTS";
    Screen["SETTINGS_MULTISIG"] = "SETTINGS_MULTISIG";
    Screen["SETTINGS_OPERATION_POPUP"] = "SETTINGS_OPERATION_POPUP";
    Screen["SETTINGS_ABOUT"] = "SETTINGS_ABOUT";
    Screen["SETTINGS_ANALYTICS"] = "SETTINGS_ANALYTICS";
    Screen["SETTINGS_NOTIFICATIONS_CONFIGURATION"] = "SETTINGS_NOTIFICATIONS_CONFIGURATION";
    Screen["SETTINGS_HELP"] = "SETTINGS_HELP";
    Screen["CHAINS"] = "CHAINS";
    Screen["UNDEFINED"] = "UNDEFINED";
})(Screen || (Screen = {}));
